import React from "react"
import { graphql } from "gatsby"

import FullQuizz from "../components/full-quizz"
import { questionnaire, parties } from "../data/source"

export default props => {
  return (
    <FullQuizz
      quizz={{ questionnaire, parties }}
      hasLocalStorage={process.env.LOCALSTORAGE}
      showStepper={process.env.SHOW_STEPPER_DEFAULT}
      typeViz={process.env.TYPE_VIZ}
      {...props}
    />
  )
}

export const query = graphql`
  query EvalVizQuery {
    site {
      siteMetadata {
        title
        social {
          name
          url
        }
      }
    }
  }
`
